import { render, staticRenderFns } from "./AutonomousTeachingActivityView.vue?vue&type=template&id=68854e82&scoped=true"
import script from "./AutonomousTeachingActivityView.vue?vue&type=script&lang=js"
export * from "./AutonomousTeachingActivityView.vue?vue&type=script&lang=js"
import style0 from "./AutonomousTeachingActivityView.vue?vue&type=style&index=0&id=68854e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68854e82",
  null
  
)

export default component.exports